"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerRating = void 0;
const Language_1 = __importDefault(require("@opsbase/lib-i18n/Language"));
const Flag_1 = require("@opsbase/lib-issue/Flag");
const useSelfLanguage_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useSelfLanguage"));
const Rating_1 = require("@opsbase/web-ui/Rating");
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importStar(require("react"));
function AnswerRating(props) {
    const { form, questionNodeId } = props;
    const questionNode = form.questions[questionNodeId];
    const answer = form.answers[questionNodeId];
    const rule = form.rules[questionNode.questionId];
    const { language } = (0, useSelfLanguage_1.default)();
    const isAlt = language !== Language_1.default.ENGLISH;
    return (0, react_1.useMemo)(() => {
        var _a;
        if (!answer.value)
            return null;
        const value = parseInt(answer.value.match(/\d+/)[0]);
        const option = rule[answer.value];
        const label = (isAlt ? ((_a = option === null || option === void 0 ? void 0 : option.labelAlt) === null || _a === void 0 ? void 0 : _a[language]) || (option === null || option === void 0 ? void 0 : option.label) : option === null || option === void 0 ? void 0 : option.label) || 'Unknown';
        const color = (0, Flag_1.flagColor)(rule[answer.value].flag);
        return (react_1.default.createElement(Tooltip_1.default, { tip: label, placement: 'bottom-end' },
            react_1.default.createElement(Rating_1.Rating, { value: value, color: color })));
    }, [answer.value, rule, isAlt, language]);
}
exports.AnswerRating = AnswerRating;
exports.default = AnswerRating;
